import axios from "@/services/config";

export const listarUsuarios = async (params) => {
  const { data, status } = await axios
    .get("/soporte/csa/usuarios", { params })
    .catch((e) => e.response);
  return { data, status };
};
